import { Link } from 'react-router-dom';
import ComicCard from './ComicCard';
import './Gallery.css';

function Gallery({ albums, series })
{
  // Group albums by serie to count them
  const serieAlbumCounts = albums.reduce((acc, album) =>
  {
    acc[album.serieId] = (acc[album.serieId] || 0) + 1;
    return acc;
  }, {});

  return (
    <div className="gallery">
      <div className="card-grid">
        { series
          .filter(serie => serieAlbumCounts[serie.id] > 0) // avoid displaying series with no albums
          .map(serie =>
          {
            const firstAlbum = albums.find(album => album.serieId === serie.id);
            const serieData = 
            { 
              ...serie,
              firstAlbum,
              albumCount: serieAlbumCounts[serie.id] || 0,
              slug: serie.nom.toLowerCase().replace(/\s+/g, '-')
            };

            return (
              <ComicCard 
                key={serieData.id}
                type="serie"
                data={serieData}
              />
            );
          }) 
        }
      </div>
    </div>
  );
}

export default Gallery;